import {Text} from '../../../../text'

export * from './checkbox'

export const TableText = props => {
	return <Text className="advanced-table-text" truncate {...props} />
}
